import apiHandler from "middlewares/apiHandler";
import {
  ClientGHGTargetModel,
  ClientGHGTargetGridModel,
} from "pages/Client/data/ClientGHGTargetModel";

export const _getClientGHGTargetsByClientId = async (clientId: number) => {
  return apiHandler.get<Array<ClientGHGTargetModel>>(
    `ClientGHGTargets/client/${clientId}`
  );
};

export const _getCustomClientGHGTargetsByClientId = async (clientId: number) => {
  return apiHandler.get<Array<ClientGHGTargetGridModel>>(
    `CustomClientGHGTargets/client/${clientId}`
  );
};

export const _getClientGHGTargetByTargetNumber = async (targetNumber: number) => {
  return apiHandler.get<ClientGHGTargetModel>(
    `ClientGHGTargets/${targetNumber}`
  );
};

export const _addClientGHGTarget = async (model: ClientGHGTargetModel) => {
  return apiHandler.post<ClientGHGTargetModel>("ClientGHGTarget", model);
};

export const _updateClientGHGTarget = async (model: ClientGHGTargetModel) => {
  return apiHandler.put<ClientGHGTargetModel>("ClientGHGTarget", model);
};

export const _deleteClientGHGTarget = async (targetNumber: number) => {
  return apiHandler.delete("ClientGHGTarget/" + targetNumber);
};
